import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class KnBrPhoneHelper {
  constructor() {}
  formatPhoneNumber(rawValue: string): string {
    if (!rawValue) {
      return '';
    }
    let digits = String(rawValue).replace(/\D/g, "");
    if (!digits.length) {
      return rawValue;
    }
    if (digits.length > 10) digits = digits.slice(0, 10);
    let formatted = digits;
    if (digits.length > 6) {
      formatted = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    } else if (digits.length > 3) {
      formatted = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    } else if (digits.length > 0) {
      formatted = `(${digits}`;
    }
    return formatted;
  }
}
